import _ from 'lodash';
import {adminBoundary} from './boundary/adminBoundary';
import { featureName } from '../../Essentials/variables';
import { getLevel,getPreLevel } from '../../Essentials/common_fn';
import {boundingExtent,extend,getCenter} from 'ol/extent'
import { RDSE_COUNT } from '../../Essentials/variables';
import React, { useState ,useEffect,useMemo, useContext, useRef}  from 'react';
export const POI = ['HOSPITALS','SCHOOLS','AGRI_MANDIS','BANKS','INDUSTRIAL_CENTER','PETROL_PUMPS','CNG_PUMPS'];



export function replaceBorderLayer(map,setMap,selection,currLayer,setCurrLayer,extent,setExtent,loader,setLoader,optionSelection){
  
    
    // console.log('selection',selection);
    let level = getLevel(selection);
    var preLevel;
    if(_.isEmpty(selection.Village)){
        preLevel = getPreLevel(level);
    }else{
        preLevel = 'Village';
    }
    // console.log("level->",level,"prelevel->",preLevel);
    setLoader({...loader,'active':true,'content':'Loading '+level+' Boundary'});
    // console.log("Selection",selection);
    const dist= _.replace(selection.District,' District','');
    const url=`${RDSE_COUNT}/${_.replace(selection.State,/ /g, '')}/${_.replace(dist,/ /g, '')}`;
    let Token=localStorage.getItem('token')
    fetch(url,{
      headers: {
        'x-access-token': localStorage.getItem('token'),
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Frame-Options': 'DENY',
        'Content-Security-Policy': "frame-ancestors 'none'",
        'Feature-Policy': "frame-ancestors 'none'"
      },
  })
      .then((res) => {console.log('res.json',res);return res?.json()})
      .then((data) => {
        // console.log("DATA ..", data);
        let boundaryVectorLayer = adminBoundary(
          level,
          selection,
          optionSelection,
          data,
        );
        // console.log("Source: ",boundaryVectorLayer.getSource());
        if (!_.isUndefined(currLayer)) {
          
          // if (_.filter(map.getAllLayers(), (l) => {
          //     return l === currLayer;}).length > 0///////ye if ko cmnt kra hai
          // ) 
          // {
            // console.log("2");
            map.removeLayer(currLayer);

            boundaryVectorLayer.once("postrender", () => {
              setCurrLayer(boundaryVectorLayer);
              var coordinates = boundaryVectorLayer
                .getSource()
                .getFeatures()
                .map((f) => f.getGeometry())
                .map(function (g) {
                  return g.getCoordinates();
                });
              // //console.log(_.flattenDepth(coordinates,3));
              var extent = boundaryVectorLayer
                .getSource()
                .getFeatures()[0]
                .getGeometry()
                .getExtent();
              var ext = boundingExtent(_.flattenDepth(coordinates, 3));
              var features = boundaryVectorLayer.getSource().getFeatures();
              var extented = null;
              features.forEach((f) => {
                let featureExtent = f.getGeometry().getExtent();
                if (extented === null) {
                  extented = featureExtent;
                } else {
                  extend(extented, featureExtent);
                }
              });

              // console.log(extent,ext);
              // //console.log(map.getView().getExtent());
              setExtent(ext);
              setLoader({ ...loader, active: false });
            });
          // }
          setTimeout(function () {
            setLoader({ ...loader, active: false });
          }, 5000);
          map.addLayer(boundaryVectorLayer);
          // console.log('bounarylayer',boundaryVectorLayer);
          // console.log("DATA ..", data);
          boundaryVectorLayer.getSource().on("change",()=>{
            var features=boundaryVectorLayer.getSource().getFeatures();
            // console.log("Features test !!", features);
              var extented = null;
          features.forEach((f) => {
            let featureExtent = f.getGeometry().getExtent();
            if (extented === null) {
              extented = featureExtent;
            } else {
              extend(extented, featureExtent);
            }
          });
          //map.getView().fit(extent, { duration: 2000 , padding: [50, 50, 50, 50]});
          map.getView().fit(extented);
          // map.getView().animate({center: getCenter(extented)});
          // map.getView().centerOn(getCenter(extented));
          })
          
        //   var extented = null;
        //   features.forEach((f) => {
        //     let featureExtent = f.getGeometry().getExtent();
        //     if (extented === null) {
        //       extented = featureExtent;
        //     } else {
        //       extend(extented, featureExtent);
        //     }
        //   });
        //   //map.getView().fit(extent, { duration: 2000 , padding: [50, 50, 50, 50]});
        //   map.getView().fit(extented);
        //   // map.getView().animate({center: getCenter(extented)});
        //   map.getView().centerOn(getCenter(extented));
        }
        // console.log("url:",currLayer?.getSource().getUrl());
        setMap(map);
      })
}





